import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import TFDVChart from 'components/Meteorology/Fields/TrackingForecast/DetailedView/Chart';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function FullscreenChart({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  if (!open) return null;

  return (
    <div className="tf-dv-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="tf-dv-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="tf-dv-fullscreen-rotate">
        <div className="tf-dv-fullscreen-chart">
          <TFDVChart titleMaxWidth={600} />
        </div>
      </div>
      <span className="tf-dv-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
